import React from 'react';
import { CareType } from '../graphQL';
import { useCareTypeConfigContext } from './CareTypeConfigContext';

type CareTypeNamesProps = {
  careTypes: readonly CareType[];
  /** Separator placed between names. Defaults to ", ". */
  separator?: string;
};

/**
 * Renders a list of care types as their display service titles (never the raw
 * CareType enum), e.g. "Psychiatry & Therapy". Use this anywhere a care-type
 * list is shown in a table cell or label so the wording stays config-driven.
 */
export const CareTypeNames = ({ careTypes, separator = ', ' }: CareTypeNamesProps) => {
  const { getServiceTitle } = useCareTypeConfigContext();
  return <>{careTypes.map(careType => getServiceTitle(careType)).join(separator)}</>;
};
